import { Currency, Product, ProductFamily } from '../../../types';

export interface Cart {
  id: string;
  subTotal: number;
  discount: number;
  total: number;
  currency: Currency;
  cartItems: CartItem[];
  expirationDate: string;
}

export interface CartItem {
  id: string;
  productFamily: ProductFamily;
  product: Product;
  currency: Currency;
  quantity: number;
  unitPrice: number;
  subTotal: number;
  discount: number;
  discountRate: number;
  total: number;
}

export interface CreateCartRequest {
  productId: string;
  quantity: number;
  isoLanguageCode: string;
}

export interface UpdateCartRequest {
  productId: string;
  quantity: number;
}

export interface CreateCartLineItemRequest {
  productId: string;
  quantity: number;
  isoLanguageCode: string;
}

export interface UpdateCartLineItemRequest {
  isoLanguageCode: string;
  quantity: number;
}

export interface Invoice {
  id: string;
  name: string;
  accountId: string;
  accountName: string;
  invoiceDate: string;
  totalInvoiceAmount: number;
  invoiceDiscountAmount: number;
  dueDate: string;
  totalInvoiceDiscountAmount: number;
  balanceDue: number;
  totalPaidAmount: number;
  status: string;
  invoiceLineItems: InvoiceItem[];
  autoBillPay: boolean;
  currency: Currency;
  latestInvoicePDF: string;
  billingType: string;
  paymentLink: string;
}

export interface InvoiceItem {
  id: string;
  name: string;
  invoiceId: string;
  amount: number;
  discountAmount: number;
  createdById: string;
  currencyIsoCode: string;
  endpoints: string;
  isShippingTaxable: boolean;
  lastModifiedById: string;
  productId: string;
  netAmount: number;
  orderItemId: string;
  paidAmount: number;
  quantity: number;
  currency: Currency;
}

export interface Agreement {
  agreementId: string;
  accountId: string;
  cartId: string;
  cartLineItemsId: string;
  status: AgreementStatus;
  ipAddress: string;
  name: string;
  dateOfSign: string;
  email: string;
  productId: string;
  signedAgreementS3Path: string;
  createdAt: string;
  product: Product;
  productFamily: ProductFamily;
}

export enum AgreementStatus {
  SIGNED = 'SIGNED',
  SIGNING = 'SIGNING',
  UNSIGNED = 'UNSIGNED',
}
